define(['angular', '../module'], function(angular, MODULE_NAME) {
    'use strict';

    var PROVIDER_NAME = 'ilmnUiToolbarOptionsProvider';

    angular.module(MODULE_NAME)
        .provider(PROVIDER_NAME, UiToolbarOptionsProvider);

    function UiToolbarOptionsProvider() {
        this.$get = function() {
            return UiToolbarOptions;
        }
    }

    function UiToolbarOptions(options) {
        this.options = options;
    }

    UiToolbarOptions.prototype = {
        findOption: function(options, label) {
            var match, self = this;

            options.some(function(option) {
                if(option.label === label) {
                    match = option;
                }
                else if(option.subOptions) {
                    match = self.findOption.call(self, option.subOptions, label);
                }
                return !!match;
            });

            return match;
        },
        updateOption: function(optionLabel, updateFn) {
            var option = this.findOption(this.options, optionLabel);
            if(option) {
                updateFn(option);
            }
        },
        addOption: function(option) {
            this.options.push(option);
        },

        setAction: function(optionLabel, action) {
            this.updateOption(optionLabel, function(option) {
                option.action = action;
            })
        },

        hideOption: function(optionLabel) {
            this.updateOption(optionLabel, function(option) {
                option.hidden = true;
            })
        },
        showOption: function(optionLabel) {
            this.updateOption(optionLabel, function(option) {
                option.hidden = false;
            })
        },

        disableOption: function(optionLabel) {
            this.updateOption(optionLabel, function(option) {
                option.disabled = true;
            })
        },
        enableOption: function(optionLabel) {
            this.updateOption(optionLabel, function(option) {
                option.disabled = false;
            })
        },
        toggleOption: function(optionLabel) {
            this.updateOption(optionLabel, function(option) {
                option.disabled = !option.disabled;
            })
        }
    };

    return PROVIDER_NAME;
});



//////////////////
// WEBPACK FOOTER
// ./ilmn-ui-toolbar/scripts/toolbarOptions.provider.js
// module id = 14
// module chunks = 0